import {
  DATE_FORMAT_DAY_LETTER,
  DATE_FORMAT_DAY_NUMBER,
  DATE_FORMAT_SHORT_MONTH,
  DATE_FORMAT_SHORT_YEAR,
} from '@constants/datetime';
import { fromBackend } from '@utils/map-date/from-backend';

const dateFormatCache = new Map<string, Intl.DateTimeFormat>();

const createDateFormatCacheKey = (locale: string, options: Intl.DateTimeFormatOptions) => {
  return `${locale}-${JSON.stringify(options)}`;
};

export const createWeekDay = (value: number, tz: string) =>
  fromBackend(value, tz).format(DATE_FORMAT_DAY_LETTER).charAt(0);
export const createDayNumber = (value: number, tz: string) => fromBackend(value, tz).format(DATE_FORMAT_DAY_NUMBER);
export const createMonthValue = (value: number, tz: string) => fromBackend(value, tz).format(DATE_FORMAT_SHORT_MONTH);
export const createYearValue = (value: number, tz: string) => fromBackend(value, tz).format(DATE_FORMAT_SHORT_YEAR);
export const formatDate = ({
  date,
  options = {},
  locale,
}: {
  date: Date;
  options: Intl.DateTimeFormatOptions;
  locale: string;
}) => {
  const cacheKey = createDateFormatCacheKey(locale, options);

  if (!dateFormatCache.has(cacheKey)) {
    try {
      const formatter = new Intl.DateTimeFormat(locale, options);
      dateFormatCache.set(cacheKey, formatter);
    } catch (e: unknown) {
      console.error('Error creating date formatter:', e);
      return '';
    }
  }
  const formatter = dateFormatCache.get(cacheKey);
  if (!formatter) {
    throw new Error(`Formatter not found for cache key: ${cacheKey}`);
  }
  return formatter.format(date);
};

export const formatDateName = (name: string, startingTime: number, timezone: string) => {
  const date = `${createWeekDay(startingTime, timezone)}${createDayNumber(startingTime, timezone)}`;
  return `${date} - ${name}`;
};
